export default __webpack_public_path__ + "static/media/d56d4fe1215e7d557116989e79fa4c8a.11d55402.svg";